import React from 'react';
import { Link } from 'react-router-dom';
import { FadeIn, StaggerContainer, StaggerItem } from './FadeIn';
import { ArrowRightIcon, GitBranchIcon, ServerCogIcon, ShieldCheckIcon } from 'lucide-react';
export function AITransformationSection() {
  const pillars = [{
    label: 'Spec-driven development',
    icon: GitBranchIcon
  }, {
    label: 'MCP server orchestration',
    icon: ServerCogIcon
  }, {
    label: 'Secure-by-design pipelines',
    icon: ShieldCheckIcon
  }];
  return <section id="ai-transformation" className="py-24 bg-navy relative overflow-hidden" data-id="element-51" data-mp="2d3hmqa93oj26">
      <div className="absolute top-0 left-1/3 w-[500px] h-[500px] bg-blue/5 rounded-full blur-[140px] pointer-events-none" data-id="element-52" data-mp="2rs5gcazdyiph"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10" data-id="element-53" data-mp="30tlftnonx0ex">
        <div className="bg-slate border border-white/10 rounded-3xl overflow-hidden" data-id="element-54" data-mp="30u4w6zynzgqu">
          <div className="grid grid-cols-1 lg:grid-cols-[1.4fr_1fr]" data-id="element-55" data-mp="2wtb928t1q5z0">
            {/* Primary content */}
            <div className="p-8 md:p-12 lg:p-14" data-id="element-56" data-mp="3pqh477y91t2h">
              <FadeIn data-id="element-57" data-mp="3tq81luia77fz">
                <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-teal/10 border border-teal/20 text-teal text-sm font-medium mb-6" data-id="element-58" data-mp="3tppzwicuo10o">
                  Services
                </div>
                <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-5 leading-tight" data-id="element-59" data-mp="7kb3j200mqft">
                  AI-Native Engineering Transformation
                </h2>
                <p className="text-xl text-gray-400 mb-4 leading-relaxed" data-id="element-60" data-mp="gjg042s0o9pc">
                  Restructure your delivery lifecycle around AI — securely,
                  compliantly, and measurably.
                </p>
                <p className="text-lg text-gray-500 mb-10 leading-relaxed max-w-2xl" data-id="element-61" data-mp="q8pvpsm2kai7">
                  FiQIS helps banks, credit unions, and fintechs move from AI
                  experimentation to AI-native engineering.
                </p>
              </FadeIn>

              <StaggerContainer className="flex flex-wrap gap-3 mb-10" data-id="element-62" data-mp="ajjp8eslyrry">
                {pillars.map(pillar => {
                const Icon = pillar.icon;
                return <StaggerItem key={pillar.label} className="inline-flex items-center gap-2 px-4 py-2 rounded-lg bg-navy border border-white/10 text-sm text-gray-300" data-id="element-63" data-mp="k9mi8ezqc5qa">
                      <Icon className="w-4 h-4 text-teal" strokeWidth={1.75} data-id="element-64" data-mp="t99kt4473hkx" />
                      {pillar.label}
                    </StaggerItem>;
              })}
              </StaggerContainer>

              <FadeIn delay={0.15} data-id="element-65" data-mp="137yqzzmqbdlc">
                <Link to="/services/ai-native-engineering" className="inline-flex items-center justify-center gap-2 bg-teal hover:bg-teal-400 text-navy font-semibold px-7 py-3.5 rounded-md transition-colors duration-200 hover:shadow-[0_0_20px_rgba(0,212,170,0.4)] text-base" data-id="element-66" data-mp="1364en9piwtsv">
                  Explore the Offering
                  <ArrowRightIcon className="w-5 h-5" data-id="element-67" data-mp="1fj84zym92tdb" />
                </Link>
              </FadeIn>
            </div>

            {/* Proof panel */}
            <FadeIn direction="left" className="bg-navy/60 border-t lg:border-t-0 lg:border-l border-white/10 p-8 md:p-12 lg:p-14 flex flex-col justify-center" data-id="element-68" data-mp="15tewj6hemuda">
              <p className="text-sm font-medium text-gray-500 uppercase tracking-widest mb-8" data-id="element-69" data-mp="wrp4byfp7reg">
                Proven in production
              </p>

              <div className="mb-10" data-id="element-70" data-mp="10v51cvvojtro">
                <p className="text-5xl lg:text-6xl font-bold text-teal mb-3 leading-none" data-id="element-71" data-mp="muaq85h8zepb">
                  97%
                </p>
                <p className="text-gray-400 leading-relaxed" data-id="element-72" data-mp="rtx2ocp94qx2">
                  Reduction in delivery time at a global enterprise, with a
                  sharp increase in successfully delivered projects.
                </p>
              </div>

              <div className="pt-8 border-t border-white/10" data-id="element-73" data-mp="2m4sju3ei5ebg">
                <p className="text-3xl font-bold text-white mb-2" data-id="element-74" data-mp="m4dmz7wljzm1">4</p>
                <p className="text-gray-400 leading-relaxed" data-id="element-75" data-mp="h5kl6cqo9x1p">
                  Organizations where the AI-DLC methodology has been
                  implemented end to end.
                </p>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}